class AwFeatureSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-aw-slider-track], .aw-feature-strip');
    this.items = [...this.querySelectorAll('[data-aw-slider-item], .aw-feature-strip__item')];
    this.previousButton = this.querySelector('.aw-feature-slider__button--prev');
    this.nextButton = this.querySelector('.aw-feature-slider__button--next');
    if (!this.track || this.items.length < 2) return;

    this.interval = Number(this.dataset.interval) || 4000;
    this.autoplay = this.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.previousButton?.addEventListener('click', () => this.move(-1));
    this.nextButton?.addEventListener('click', () => this.move(1));
    this.track.addEventListener('scroll', () => this.update(), { passive: true });
    this.track.addEventListener('pointerdown', () => this.stop());

    if (this.dataset.pauseHover === 'true') {
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
    }

    this.observer = new IntersectionObserver(([entry]) => {
      this.visible = entry.isIntersecting;
      this.visible ? this.start() : this.stop();
    }, { threshold: 0.25 });
    this.observer.observe(this);
    this.visibilityHandler = () => document.hidden ? this.stop() : this.start();
    document.addEventListener('visibilitychange', this.visibilityHandler);
    this.update();
  }

  disconnectedCallback() {
    this.stop();
    this.observer?.disconnect();
    document.removeEventListener('visibilitychange', this.visibilityHandler);
  }

  move(direction) {
    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    const step = this.items[0].getBoundingClientRect().width + gap;
    const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
    const atStart = this.track.scrollLeft <= 4;
    if (direction > 0 && atEnd) this.track.scrollTo({ left: 0, behavior: 'smooth' });
    else if (direction < 0 && atStart) this.track.scrollTo({ left: this.track.scrollWidth, behavior: 'smooth' });
    else this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  update() {
    const hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
    if (this.previousButton) this.previousButton.hidden = hidden;
    if (this.nextButton) this.nextButton.hidden = hidden;
  }

  start() {
    if (!this.autoplay || !this.visible || this.timer || this.track.scrollWidth <= this.track.clientWidth + 2) return;
    this.timer = setInterval(() => this.move(1), this.interval);
  }

  stop() {
    clearInterval(this.timer);
    this.timer = null;
  }
}

if (!customElements.get('aw-feature-slider')) customElements.define('aw-feature-slider', AwFeatureSlider);
